// extracted by mini-css-extract-plugin
export default {"box":"SearchCity_box__h4YBL"};